import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "submit"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasEmailTarget || !this.hasSubmitTarget) return

    this.submitTarget.disabled = !this.emailTarget.checkValidity()
  }
}
